import app from '../app';

const disabledShowItems = [];
const disabledLoadItems = [];

app.directive('cianAfElementInViewport', [
  'analyticsService',
  'placingTermsApi',
  (analyticsService, placingTermsApi) => ({
    link($scope, element, attr) {
      const el = element[0];

      if (typeof window === 'undefined' || !('IntersectionObserver' in window) || !el) {
        return;
      }

      const intersectionRatioThreshold = Number(attr.intersectionRatio) || 0.5;
      const intersectionViewTimeThreshold = Number(attr.intersectionViewTime) || 1000;
      const rootMargin = '0px';
      const root = null;

      let isVisible = false;
      let isViewed = false;
      let refreshIntervalID = null;

      function callViewportCallback(isTeaserShow) {
        if (attr.trackOnce) {
          if (!isTeaserShow) {
            if (disabledLoadItems.includes(attr.blockLocation)) {
              return;
            } else {
              disabledLoadItems.push(attr.blockLocation);
            }
          } else if (isTeaserShow) {
            if (disabledShowItems.includes(attr.blockLocation)) {
              return;
            } else {
              disabledShowItems.push(attr.blockLocation);
            }
          }
        }

        if (attr.isPublishTerms) {
          placingTermsApi[attr.intersectionCallback]();
        } else {
          analyticsService[attr.intersectionCallback]();
        }
      }

      function updateTotalViewTime(element) {
        const lastStarted = element.dataset.lastViewStarted;
        const currentTime = performance.now();

        if (lastStarted) {
          const diff = currentTime - Number(lastStarted);
          element.dataset.totalViewTime = String(Number(element.dataset.totalViewTime) + diff);
        }

        element.dataset.lastViewStarted = String(currentTime);
      }

      function removeVisibleElement() {
        isVisible = false;

        if (refreshIntervalID !== null) {
          window.clearInterval(refreshIntervalID);
          refreshIntervalID = null;
        }
      }

      function moveElementToViewed() {
        if (!isViewed) {
          isViewed = true;
          callViewportCallback(true);
        }

        if (attr.trackMultiple && isViewed) {
          isViewed = false;
        }

        removeVisibleElement();
      }

      function checkVisibleElement(element) {
        if (isVisible) {
          if (Number(element.dataset.totalViewTime) >= intersectionViewTimeThreshold) {
            moveElementToViewed(element);
          }
        }
      }

      function handleRefreshInterval() {
        updateTotalViewTime(el);
        checkVisibleElement(el);
      }

      function addVisibleElement({ time, target }) {
        target.dataset.lastViewStarted = String(time);
        target.dataset.totalViewTime = '0';

        isVisible = true;
        if (refreshIntervalID === null) {
          window.setInterval(handleRefreshInterval, intersectionViewTimeThreshold);
        }
      }

      function intersectionCallback(elements) {
        elements.forEach(element => {
          if (element.isIntersecting && element.intersectionRatio >= intersectionRatioThreshold) {
            addVisibleElement(element);
          } else {
            if (Number(element.target.dataset.totalViewTime) >= intersectionViewTimeThreshold) {
              checkVisibleElement(element.target);
            } else {
              removeVisibleElement(element.target);
            }
          }
        });
      }

      const observer = new IntersectionObserver(intersectionCallback, {
        root,
        rootMargin,
        threshold: [0, intersectionRatioThreshold],
      });

      observer.observe(el);

      $scope.$on('$destroy', () => {
        observer.unobserve(el);
        isViewed = false;
        removeVisibleElement();
      });
    },
  }),
]);
